import { gql } from "@apollo/client";
import { ImageFragment } from "./image";

export const KnowledgeBaseBaseFragment = gql`
  fragment KnowledgeBaseBaseFragment on KnowledgeBase {
    createdAt
    publishedAt
    title
    slug
    duration
    knowledgeBaseType {
      data {
        id
        attributes {
          type
        }
      }
    }
    briefDescription
    cover {
      data {
        ...ImageFragment
      }
    }
    DefaultContentTemplate {
      __typename
      ... on ComponentCommonAuthorDetailed {
        authors: authors_connection {
          data {
            attributes {
              name
              role
              bio
              avatar {
                data {
                  ...ImageFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

export const KnowledgeBaseCategoryFragment = gql`
  fragment KnowledgeBaseCategoryFragment on KnowledgeBaseCategory {
    documentId
    category
    subCategories: subCategories_connection {
      nodes {
        documentId
        category
        subCategories: subCategories_connection {
          nodes {
            documentId
            category
            subCategories: subCategories_connection {
              nodes {
                documentId
                category
              }
            }
          }
        }
      }
    }
  }
`;
